<div class="icon-cont">
  <a class="social-icon" target="_blank" href="{{componentData.url}}" role="button">
      <i class="sg-icon sg-icon-linkedin"></i>
  </a>
</div>
